<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :value="'增量同步'" @click="synchronize" v-if="permissionCodes.indexOf('041001001') !== -1"/>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search  placeholder="客户名称"  @search="searchKey"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination"  :operationArr="operationArr" :hasOperation="false"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Group";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "customer-master-data",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "数据对接",
          name: "customer-master-data"
        },
        {
          value: "客户主数据"
        }
      ],
      tableHead: [
        {
          prop: "customerCode",
          label: "客户编码"
        },
        {
          prop: "customerName",
          label: "客户名称"
        },
        {
          prop: "address",
          label: "客户地址"
        },
        {
          prop: "companyTelephone",
          label: "住户电话"
        },
        {
          prop: "contactPerson",
          label: "联系人"
        },
        {
          prop: "cpMobile",
          label: "联系人手机"
        },
        {
          prop: "taxNumber",
          label: "税号"
        },
        {
          prop: "companyCode",
          label: "住户代码"
        },
        {
          prop: "syncTime",
          label: "同步时间"
        }
      ],
      tableData: [],
      total: 0,
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      operationArr: []
    };
  },
  created() {
    this.getPage();
    this.permissionCodes = bus.global.permissionCodes;
  },
  methods: {
    changePagination(data) {
      this.requestData.pageSize = data[1];
      this.requestData.pageNum = data[0];
      this.getPage();
    },
    getPage() {
      this.$axios
        .post(api.getCustomerPage, this.requestData)
        .then(res => {
          this.tableData = res.data.data.list;
          this.total=res.data.data.total
        })
        .catch(errorHandler("获取分页失败"));
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    synchronize() {
      this.$axios
        .post(api.getCustomerSync, {})
        .then(res => {
          nSuccess("同步成功");
          this.getPage();
        })
        .catch(errorHandler("同步失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/DataSync/CustomerMasterData/CustomerMasterData.vue